<template>
  <div class="video-container">
    <div class="video-guide-tip" @click="queryIsVillage">
      <i class="icon-pointer"></i>
      <span>点击视频，跳转至大屏模式</span>
    </div>

    <!-- 原有视频元素保持不变 -->
    <video
      class="fullscreen-video"
      src="@/assets/video/homeVideo.mp4"
      autoplay
      muted
      loop
      playsinline
      @click="queryIsVillage"
    >
      您的浏览器不支持视频播放
    </video>
  </div>
</template>

<script>
export default {
  methods: {
    fullScreen() {
      const element = document.querySelector('.video-container');
      if (!element) return;

      const requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        const wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    },
    queryIsVillage() {
      const userStr = localStorage.getItem('USER');
      if (!userStr) {
        this.$message.error('未获取到用户信息');
        return;
      }

      try {
        const user = JSON.parse(userStr);
        const { streetId } = user;

        if (!streetId) {
          this.$message.warning('用户信息中未包含街道ID');
          return;
        }

        this.$post('/api/data/query', {
          key: 'web_queryIsVillage',
          streetId: streetId
        }).then(res => {
          if (!res || !res.data) {
            this.$message.error('接口响应格式异常');
            return;
          }

          const data = res.data.data;
          if (!data) {
            this.$message.warning('无数据返回');
            return;
          }

          const regionData = Array.isArray(data) ? data[0] : data;
          if (regionData.level === undefined) {
            this.$message.error('地区数据格式不正确');
            return;
          }

          const { level } = regionData;
          let url = '';

          if (level >= 1 && level <= 3) {
            url = 'https://county.jinchanhb.com';
          } else if (level === 4) {
            url = `http://datav.jinchanhb.com/#/home?streetId=${streetId}`;
          } else if (level >= 5) {
            url = `http://datav.jinchanhb.com/#/town?streetId=${streetId}`;
          } else {
            this.$message.warning('未匹配到对应的地区级别');
            return;
          }

          window.location.href = url;

        }).catch(error => {
          console.error('请求失败:', error);
          this.$message.error('查询失败，请稍后重试');
        });

      } catch (error) {
        console.error('解析用户信息失败:', error);
        this.$message.error('解析用户信息失败');
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.video-container {
  position: fixed;
  width: 100vw;
  height: 89vh;
  z-index: 1;
  overflow: hidden;
  /* 作为提示的定位容器 */
  position: relative;
  cursor: pointer;
}

.fullscreen-video {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  cursor: pointer;
}
.video-guide-tip {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(255, 68, 0, 0.9);
  color: #fff;
  padding: 12px 24px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: pulse 2s infinite ease-in-out;
  user-select: none;
}

.icon-pointer {
  width: 18px;
  height: 18px;
  border: 2px solid #fff;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  position: relative;
  animation: pointerBounce 1.5s infinite;
}

.icon-pointer::after {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  top: 3px;
  left: 3px;
}

@keyframes pulse {
  0%, 100% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.05);
  }
}

@keyframes pointerBounce {
  0%, 100% {
    transform: rotate(-45deg) translateY(0);
  }
  50% {
    transform: rotate(-45deg) translateY(-5px);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .video-guide-tip {
    padding: 10px 20px;
    font-size: 14px;
    bottom: 20px;
  }

  .icon-pointer {
    width: 16px;
    height: 16px;
  }
}

@media (max-height: 480px) {
  .video-guide-tip {
    padding: 8px 16px;
    font-size: 12px;
    bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomePage0.vue